import { c as _c } from "react/compiler-runtime";
import type { ButtonProps } from '@common/components';
import { Button } from '@common/components';
import { cn } from '@core/utils';
export interface FooterButtonProps extends ButtonProps {
  shape?: ButtonProps['roundness'];
}
export const ButtonFooter = t0 => {
  const $ = _c(14);
  let className;
  let restButtonProps;
  let shape;
  let style;
  if ($[0] !== t0) {
    ({
      className,
      style,
      shape,
      ...restButtonProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = restButtonProps;
    $[3] = shape;
    $[4] = style;
  } else {
    className = $[1];
    restButtonProps = $[2];
    shape = $[3];
    style = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("sticky bottom-0 mt-auto box-border border-t border-Gray-300 bg-Gray-white p-20", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== restButtonProps || $[8] !== shape) {
    t2 = <Button {...restButtonProps} className="w-full" roundness={shape} />;
    $[7] = restButtonProps;
    $[8] = shape;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== style || $[11] !== t1 || $[12] !== t2) {
    t3 = <footer className={t1} style={style}>{t2}</footer>;
    $[10] = style;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};